import { useSelector } from 'react-redux';
import { selectEmergencyCutoverLock } from '@department-of-veterans-affairs/platform-user/selectors';

/**
 * Returns true when the given MHV tool is currently locked by the Oracle Health
 * emergency cutover brake (i.e., the tool's key is present in the
 * `emergencyCutoverLock` array from the user profile).
 *
 * @param {string} toolKey - Tool identifier (e.g. 'sm', 'rx', 'mr').
 *   Use the values from EMERGENCY_CUTOVER_LOCK_KEYS in platform/mhv/util/constants.
 * @returns {boolean}
 */
const useEmergencyCutoverLock = toolKey => {
  const emergencyCutoverLock = useSelector(selectEmergencyCutoverLock);
  return emergencyCutoverLock.includes(toolKey);
};

export default useEmergencyCutoverLock;
